import { FieldInputProps } from "formik";

interface TextCellProps extends FieldInputProps<any> {
  hasError?: boolean;
  customStyles?: string;
}

const TextCell = ({
  name,
  value,
  onChange,
  onBlur,
  ...props
}: TextCellProps) => {
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      target: {
        name,
        value: e.target.value,
      },
    });
  };

  const defaultStyles = `w-full outline-none transition-all duration-200 bg-white focus:bg-gray-100 px-2 py-1 
    truncate text-ellipsis overflow-hidden whitespace-nowrap
    ${props.hasError ? "placeholder-red-500" : ""}`;

  return (
    <div className="relative flex items-center rounded-md">
      <input
        {...props}
        type="text"
        name={name}
        value={value ?? ""}
        onChange={handleValueChange}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onBlur(e as unknown as React.FocusEvent<HTMLInputElement>);
          }
        }}
        placeholder={props.hasError ? "*Required" : ""}
        className={`${
          props.customStyles
            ? `${props.customStyles} ${defaultStyles}`
            : defaultStyles
        } ${props.hasError ? "placeholder-red-500" : ""}`}
      />
    </div>
  );
};

export default TextCell;
